import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';
import logo from '../logo.png';

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();

  const menuItems = [
    { path: '/', label: 'Pré-Offres', icon: '🔔' },
    { path: '/companies', label: 'Entreprises', icon: '🏢' },
    { path: '/employees', label: 'Employés', icon: '👥' },
    { path: '/offers', label: 'Offres', icon: '🎁' },
    { path: '/support', label: 'Support', icon: '🛠️' },
    { path: '/notifications', label: 'Notifications', icon: '🔔' }, // ✅ AJOUTER
    { path: '/surveys', label: 'Enquêtes', icon: '📊' }, // ✅ AJOUTER CETTE LIGNE
    { path: '/validation', label: 'Validation', icon: '✅' },
    { path: '/contacts', label: 'Contacts', icon: '✉️' },
  ];

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <div className="logo-icon">
            <img 
              src={logo} 
              alt="Logo Avantagea" 
              className="logo-image"
            />
          </div>
          <div className="logo-text">
            <h2 className="logo-title">Avantagea</h2>
            <p className="logo-subtitle">Espace Super Admin</p>
          </div>
        </div>
      </div>
      
      <nav className="sidebar-nav">
        {menuItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={onClose} // Ferme la sidebar au click sur mobile
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
            <div className="nav-indicator"></div>
          </Link>
        ))}
      </nav>
      
      <div className="sidebar-footer">
        <div className="sidebar-status">
          <div className="status-dot"></div>
          <span className="status-text">Système en ligne</span>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;